module.exports = __webpack_public_path__ + "static/media/bg-mobilefull.6bc8e77a.svg";